import React from 'react';
import { Button, Typography } from 'antd';

const { Text } = Typography;

export default function PromptRail({ label, questions, onSelect, loading }) {
  if (!questions.length) return null;

  return (
    <div className="glp1-prompt-block">
      {label ? (
        <Text type="secondary" className="glp1-prompt-label">
          {label}
        </Text>
      ) : null}
      <div className="glp1-prompt-rail">
        {questions.map((item) => (
          <Button key={item} className="glp1-prompt-button" onClick={() => onSelect(item)} disabled={loading}>
            {item}
          </Button>
        ))}
      </div>
    </div>
  );
}
